import { graphql } from 'ms-client/graphql/user-pool'
import {
  EmbedMapMutation,
  EmbedMapMutationVariables
} from '~map-preview/types/__generated/gql/graphql'

import { mapSharedEvent } from 'tag-manager/map_shared'

const embedMapMutation = /* GraphQL */ `
  mutation EmbedMap($mapId: ID!) {
    embedMap(mapId: $mapId)
  }
`

export const embedMap = async (variables: EmbedMapMutationVariables) => {
  const data = await graphql<EmbedMapMutation, EmbedMapMutationVariables>({
    query: embedMapMutation,
    variables
  })
  mapSharedEvent('embed_code')
  return data?.embedMap
}
